import React from 'react'
import {
  TableHead,
  TableBodyRow
} from './../../../../../widget/styledComponents/table.style'
import { 
  GuestListTableContainer,
} from './../../dues/dues.style';
import {
PageContainerTitleText
} from '../../../../../widget/styledComponents/headings.style';

import { Checkbox, Dialog, Pagination, Pane, Spinner, Tooltip, toaster} from 'evergreen-ui';
import { gql,useQuery } from '@apollo/client';
import CircleProgressLoader from '../../../../../widget/circle_progress_loader';
import { Popover,Menu,Position } from 'evergreen-ui';
import Cookies from 'js-cookie';
// import RefreshButton from '../../../../../widget/styledComponents/refreshButton';



export const FETCH_ALL_ESTATE = gql`
query Facilities {
  facilities {
    _id
    code
    name
    facilityManager
    totalProperties
    occupiedProperties
    availableProperties
    address
    country
    state
    city
    createdAt
    id
  }
}
`;


function PropertyMetricWidget() {
const { loading, data }  = useQuery(FETCH_ALL_ESTATE);
const [checked, setChecked] = React.useState(false)
const [isShown, setIsShown] = React.useState(false)
  return (
    <div>
      <GuestListTableContainer>
      <small>Note: CLick on the estate name to switch or select.</small>
            <PageContainerTitleText>
                Estates
            </PageContainerTitleText>
            {/* <RefreshButton/> */}
            <table className='responsive-table'>
                <thead>
                <tr>
                    <TableHead>
                      <Checkbox
                      label=""
                      checked={checked}
                      onChange={e => setChecked(e.target.checked)}
                      />
                      {/* <i className='material-icons'>check_box_outline_blank</i> */}
                    </TableHead>
                    <TableHead>Name</TableHead>
                    <TableHead>TotalProperties</TableHead>
                    <TableHead>OccupiedProperties</TableHead>
                    <TableHead>AvailableProperties</TableHead>
                    <TableHead>Actions</TableHead>

                    
                </tr>
                </thead>

                <tbody>
                <Dialog
                  isShown={isShown}
                  title="Dialog title"
                  onCloseComplete={() => setIsShown(false)}
                  confirmLabel="Custom Label"
                  width={100}
                  hasHeader={false}
                  hasFooter={false}
                  shouldCloseOnEscapePress={false}
                  shouldCloseOnOverlayClick={false}
                >
                    <Pane display="flex" alignItems="center" className='pt-16' justifyContent="center" height={50}>
                      <Spinner className='mt-25' />
                    </Pane>
                  
                </Dialog>
                {loading && <CircleProgressLoader/> }
                {/* {error && <small>{error.toString()}</small>} */}
                {data &&
                    
                    data.facilities.map((estate) => <TableBodyRow

                    
                            
                          >
                            <td 
                                className='pl-2'
                            >
                                <Checkbox
                                    label=""
                                    checked={checked}
                                />
                            </td>
                            <Tooltip content="Click to switch estate" 
                             
                            >
                              <td  onClick={()=>{
                                
                                toaster.success(`${estate.name} selected.`)
                                Cookies.set('facilityId',`${estate._id}`)
                                Cookies.set('facilityCode',`${estate.code}`)
                                Cookies.set('facilityName',`${estate.name}`)
                                Cookies.set('facilityTotalProperties',`${estate.totalProperties}`)
                                Cookies.set('facilityOccupiedProperties',`${estate.occupiedProperties}`)
                                Cookies.set('facilityAvailableProperties',`${estate.availableProperties}`)
                                setIsShown(true)
                                window.location.reload()
                                
                            }}>
                                  {estate.name}
                              </td>
                            </Tooltip>

                            <td>{estate.totalProperties}</td>
                            <td>{estate.occupiedProperties}</td>
                            <td>{estate.availableProperties}</td>
                            <td>
                              <EstateActionBtn/>
                            </td>
                            
                        </TableBodyRow> 
                    )
                }
                    
                </tbody>
            </table>
            <Pagination className='transparent z-depth-0' page={1} totalPages={1}></Pagination>
        </GuestListTableContainer>
    </div>
  )
}

export default PropertyMetricWidget



export function EstateActionBtn() {
  return (
  <Popover
    position={Position.BOTTOM_LEFT}
    content={
      <Menu style={{
        background:"blue !important"
      }}>
        <Menu.Group >
          <Menu.Item onSelect={null}>Edit</Menu.Item>
          <Menu.Item onSelect={null}>Delete</Menu.Item>
        </Menu.Group>
      </Menu>
    }
  >
  <button className='btn btn-flat center grey-text' marginRight={16}>
    <i className='material-icons'>more_horiz</i>
  </button>
</Popover>
  )
}








